import {css} from '@emotion/css';
import {elementSize, spacing, coloursV2, darken} from '@fo/shared/styles/variables';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';

export default {
  componentWrapper: css`
    label: navigationDesktop__componentWrapper;
    width: 100%;
    display: none;
    ${mq(Breakpoints.DESKTOP)} {
      display: block;
    }
  `,
  topBar: css`
    label: navigationDesktop__topBar;
    position: relative;
    display: flex;
    justify-content: center;
    background-color: ${coloursV2.background.lightGray};
    z-index: 899;
  `,
  topBarContents: css`
    label: navigationDesktop__topBarContents;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: ${elementSize.container.XXXL};
    padding: 0 ${spacing.S};
  `,
  user: css`
    label: navigationMobile__user;
    margin-left: ${spacing.XXS};
    z-index: 900;
  `,
  login: css`
    label: headerMainBar__login;
    display: flex;
    align-items: center;
    margin-left: ${spacing.XXS};
  `,
  loginText: css`
    label: headerMainBar__loginText;
    margin-right: ${spacing.XXXS};
  `,
  mainBar: css`
    label: navigationDesktop__mainBar;
    position: relative;
    display: flex;
    justify-content: center;
    background-color: ${coloursV2.background.white};
    border-bottom: 1px solid ${darken(coloursV2.background.lightGray)};
    z-index: 898;
  `,
  mainBarContents: css`
    label: navigationDesktop__mainBarContents;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: ${elementSize.container.XXXL};
    padding: 0 ${spacing.S};
    height: 11rem;
  `,
  logo: css`
    label: navigationDesktop__logo;
    width: auto;
    height: 6rem;
    vertical-align: middle;
  `,
  link: css`
    label: navigationDesktop__link;
    display: flex;
    flex-shrink: 1;
    justify-content: flex-start;
    align-items: center;
    padding: ${spacing.XXS} ${spacing.XXS} ${spacing.XXS} 0; // stylelint-disable-line sh-waqar/declaration-use-variable
    height: auto;
    vertical-align: middle;
    text-decoration: none;
    color: ${coloursV2.generic.black};
    ${mq(Breakpoints.TABLET)} {
      margin-bottom: 0;
    }
  `,
  sectionsLabelsContainer: css`
    label: navigationDesktop__sectionsLabelsContainer;
    display: flex;
    flex: 1;
    height: 100%;
    padding: 0 ${spacing.XS};
  `,
  sectionLabelTrigger: css`
    label: navigationDesktop__sectionLabelTrigger;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 1;
    width: auto;
    height: 100%;
    padding: 0 ${spacing.XXS};
    border-radius: unset;
    cursor: pointer;
    svg {
      transform: rotate(-90deg);
      transition: transform 250ms;
    }
    #navigation__sectionsContentsWrapper {
      display: none;
    }
    &:hover {
      background-color: ${coloursV2.background.lightGray};
      svg {
        transform: rotate(90deg);
      }
      #navigation__sectionsContentsWrapper {
        display: flex;
      }
    }
  `,
  sectionLabelTriggerCaret: css`
    label: navigationDesktop__sectionLabelTriggerCaret;
    margin-left: 0.8rem;
    margin-right: -0.2rem;
  `,
  sectionsContentsWrapper: css`
    label: navigationDesktop__sectionsContentsWrapper;
    position: absolute;
    justify-content: center;
    top: 100%;
    left: 0;
    width: 100%;
    min-height: 34rem;
    background-color: ${coloursV2.generic.white};
    box-shadow: 0px 4px 85px rgba(0, 0, 0, 0.025);
    z-index: 897;
  `,
  sectionsContents: css`
    label: navigationDesktop__sectionsContents;
    display: flex;
    width: 100%;
    max-width: ${elementSize.container.XXXL};
    padding: 0 ${spacing.S};
  `,
};
